import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";

import { connect } from 'react-redux';

import { fetchPaymentMethods } from 'reducers/paymentmethod/paymentmethodActions'
import { fetchAccountBalance } from 'reducers/account/accountActions'
import { showWarningMessage } from 'reducers/application/applicationActions'
import { updatePaymentMethod } from 'reducers/quotastopay/quotastopayActions'
import { getCCUrlPayment } from 'reducers/payment/paymentActions'

import { formatToDecimal } from 'utils/Number/NumberUtils';

import PaymentDetail from './PaymentDetail';

import { CREDIT_DEBIT_CARD, TIGO_MONEY, ACCOUNT } from './paymentMethodConst'

import Radio from "components/CustomRadio/CustomRadio.jsx";

class PaymentMethodStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethodSel: 0
    }
  }

  componentWillMount() {
    this.props.fetchAccountBalance();
    this.props.fetchPaymentMethods();
  }

  handleRadio = (event, paymentMethod) => {
    const target = event.target;
    this.props.updatePaymentMethod(paymentMethod, this.props.accountInfo.balance);
    this.setState({
      [target.name]: target.value,
      paymentMethodSel: target.value
    });
  };

  isValidated() {

    if (!this.isSomePaymentMethodSelected()) {
      this.props.showWarningMessage(
          "Por favor seleccionar un metodo de pago"
      );
      return false;
    }

    if (!this.props.paymentMethod) {
      this.props.showWarningMessage(
          "Por favor seleccionar un metodo de pago"
      );
      return false;
    }

    if (this.props.paymentMethod.type === ACCOUNT) {
      return this.validateAccount();
    }

    if (this.props.paymentMethod.type === CREDIT_DEBIT_CARD) {
      return new Promise((resolve, reject) => {
        this.getCreditCardUrlPayment(resolve, reject);
      });
    }

    return true;
  }

  getCreditCardUrlPayment(resolve, reject) {
    let paymentDto = {
      saleOrderId: this.props.quotasToPay.saleOrder.id,
      totalToPay: this.props.quotasToPay.totalToPay,
      quotaToPayDtos: this.props.quotasToPay.quotasDetail,
      paymentMethodId: this.props.quotasToPay.paymentMethod.id
    };
    this.props.getCCUrlPayment(paymentDto, resolve, reject);
  }

  validateAccount() {
    if (this.props.accountInfo.balance == 0) {
      this.props.showWarningMessage("Usted no dispone de saldo en su cuenta");
      return false;
    }

    if (this.props.accountInfo.balance < this.props.totalToPay) {
      this.props.showWarningMessage("El monto de la cuenta no cubre el monto 'Total a Pagar'");
      return false;
    }
    return true;
  }

  isSomePaymentMethodSelected() {
    return this.state.paymentMethodSel != 0;
  }

  getPaymentName(paymentMethod) {
    if (paymentMethod.type === ACCOUNT) {
      return <span>{paymentMethod.name} <b>{"(" + formatToDecimal(this.props.accountInfo.balance) + "$)"} </b></span>;
    } else {
      return paymentMethod.name;
    }
  }

  render() {
    return (
      <div className="wizard-step">
        <Row>
          <Col md={5} mdOffset={1}>
            <h3 className="title"><b>Seleccionar método de pago:</b></h3>
            <div className="payment-method-step__radio">
              {this.props.paymentMethods.map((paymentMethod, key) => {
                return (
                  <div key={key}>
                    <Radio
                      number={paymentMethod.id}
                      option={paymentMethod.id}
                      name="paymentMethod"
                      onChange={(evt) => this.handleRadio(evt, paymentMethod)}
                      label={this.getPaymentName(paymentMethod)}
                    />
                    <img className="payment-method__img"
                      src={paymentMethod.logo} />
                  </div>
                );
              })}
            </div>
          </Col>
          <Col md={5}>
            <PaymentDetail />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  paymentMethods: state.paymentMethods.items,
  accountInfo: state.account.info,
  totalToPay: state.quotasToPay.totalToPay,
  quotasToPay: state.quotasToPay,
  paymentMethod: state.quotasToPay.paymentMethod
});

export default connect(
  mapStateToProps,
  { fetchPaymentMethods, showWarningMessage, fetchAccountBalance, updatePaymentMethod, getCCUrlPayment },
  null,
  { withRef: true }
)(PaymentMethodStep);


// WEBPACK FOOTER //
// ./src/components/PaymentWizard/PaymentMethodStep.jsx